import React from 'react';
import './ServicesOtherservices.scss';
import SectionPlain from '../../components/SectionPlain';
import ServicesCard from '../../components/cards/ServicesCard';
import Button from '../../components/Button';

const ServicesOtherServices = ({
  title,
  subTitle,
  services,
  auditTitle,
  auditBody,
  auditButton,
}) => (
  <SectionPlain className="services-other-services" subTitle={subTitle} title={title} titleH2>
    <div className="services__cards-container">
      {services.map((card) => (
        <ServicesCard
          image={card.imageContainer.image.publicURL}
          altText={card.imageContainer.altText}
          title={card.title}
          description={card.description}
          key={card.title}
        />
      ))}
    </div>
    <div className="services-other-services__audit">
      <h2 data-sal="slide-up" data-sal-easing="ease">
        {auditTitle}
      </h2>
      <p
        className="body-2 body-2--white services-other-services__audit-body"
        data-sal="slide-up"
        data-sal-easing="ease"
      >
        {auditBody}
      </p>
      <div data-sal="slide-up" data-sal-easing="ease">
        <Button variant="secondaryWhite" to={auditButton.url}>
          {auditButton.text}
        </Button>
      </div>
    </div>
  </SectionPlain>
);

export default ServicesOtherServices;
